export default {
  COUNTRY_CODE: 'SA',
  ID: 'ar-sa',
  NUMBER_FORMAT: {
    CURRENCY_DESCRIPTION: 'Saudi Riyal',
    CURRENCY_SYMBOL: 'SAR',
    DECIMAL_SEPARATOR: '\u066b',
    GROUP_SEPARATOR: '\u066c',
  },
};
